import { loginError, loginSuccess, loginStart, logoutSuccess } from "./reducer";
import { ThunkAction } from "redux-thunk";
import { Action, Dispatch } from "redux";
import { RootState } from "slices";
import { getLogout, postLogin } from "helpers/backend_helper";
import { getByEmail, getByUserName, getUserRole } from "services/user.service";

interface User {
    email: string;
    password: string;
}

export const loginUser = (
    user: User,
    history: any
): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch: Dispatch) => {
    try {
        dispatch(loginStart());
        let response: any;
        response = await postLogin({
            userNameOrEmailAddress: user.email,
            password: user.password,
            rememberMe: false,
        });

        if (!response?.data) {
            return;
        } else {
            localStorage.setItem("authUser", response.data.access_token);
            localStorage.setItem("refreshToken", response.data.refresh_token);
            const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.email);
            const getUser = isEmail ? getByEmail : getByUserName;

            getUser(user.email)
                .then((res: any) => {
                    if (!res) return;
                    localStorage.setItem("userName", res.name);
                    localStorage.setItem("name", res.name + (res.surname !== null ? " " + res.surname : ""));
                    return getUserRole(res.id);
                })
                .then((roleRes: any) => {
                    if (roleRes?.items?.length > 0) {
                        localStorage.setItem("role", roleRes.items[0].name);
                        dispatch(loginSuccess(response?.data));
                        history("/conversation");
                    }
                })
                .catch((err: any) => (err));
        }

    } catch (error: any) {

        dispatch(loginError(error.message));
    }
};

export const logoutUser = () => async (dispatch: Dispatch) => {
    try {
        localStorage.removeItem("authUser");
        localStorage.removeItem("role");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("userName");
        if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        } else {
            const response = await getLogout({});
            if (response.status !== 204) {
                return;
            }
            dispatch(logoutSuccess(true));
        }
    } catch (error) {
        dispatch(loginError(error));
    }
}